<template>
  <InvoiceForm />
</template>

<script>
import InvoiceForm from '~/components/pages/document-flow/InvoiceForm.vue'

export default {
  name: 'DocumentFlowInvoicesCreate',
  components: { InvoiceForm },
}
</script>
